<template>
    <div>
        <kgr-form-row
            :label="$t('offering.commentField')"
            :error="error"
            field-name="showCommentField"
        >
            <kgr-checkbox
                v-model="offering.showCommentField"
                :label="$t('offering.commentField.showCommentField')"
                style="margin-top: 1em; margin-bottom: 1em;"
            />
        </kgr-form-row>
        <div v-show="offering.showCommentField">
            <kgr-form-row
                :label="$t('offering.commentField.commentFieldCaption')"
                :error="error"
                field-name="commentFieldCaption"
            >
                <input
                    v-model="offering.commentFieldCaption"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
        </div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow.vue';
import Offering from '../../js/dto/offering/Offering';

export default {
    name: 'KgrCommentFieldSettingComponent',
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-form-row': FormRow,
    },
    props: {
        offering: {
            type: Offering,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
